import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const TicketsPage = lazy(() => import('./pages/TicketsPage'));
const RoutingPage = lazy(() => import('./pages/RoutingPage'));
const StatusTrackingPage = lazy(() => import('./pages/StatusTrackingPage'));
const PriorityPage = lazy(() => import('./pages/PriorityPage'));

export const TicketsRoutes: RouteObject = {
  path: 'tickets',
  element: <ModuleGuard moduleId="support.tickets" />,
  handle: { crumb: 'Ticket Management' },
  children: [
    { index: true, element: <Navigate to="tickets" replace /> },
    { path: 'tickets', element: <TicketsPage />, handle: { crumb: 'Tickets' } },
    { path: 'routing', element: <RoutingPage />, handle: { crumb: 'Routing' } },
    { path: 'status-tracking', element: <StatusTrackingPage />, handle: { crumb: 'Status Tracking' } },
    { path: 'priority', element: <PriorityPage />, handle: { crumb: 'Priority' } },
  ],
};
